import { CampaignGroupIdSchema as c, TargetGroupIdSchema as r, CreativeGroupIdSchema as o, CreativeIdSchema as m, LandingIdSchema as t, LandingGroupIdSchema as n, AdGroupIdSchema as p, CampaignIdSchema as d, AssetIdSchema as i, BlacklistAutoRuleIdSchema as I, GoalIdSchema as u, RotatorCampaignIdSchema as b } from "@hprofits/shared";
import { z as e } from "zod";
const h = 2147483647, g = (a) => e.array(e.coerce.number().max(h).pipe(a)), G = e.object({
  campaignId: e.coerce.number().pipe(c)
}), l = e.object({
  targetGroupId: e.coerce.number().pipe(r)
}), P = e.object({
  creativeGroupId: e.coerce.number().pipe(o)
}), j = e.object({
  creativeId: e.coerce.number().pipe(m)
}), C = e.object({
  landingId: e.coerce.number().pipe(t)
}), A = e.object({
  landingGroupId: e.coerce.number().pipe(n)
}), v = e.object({
  adGroupId: e.coerce.number().pipe(p)
}), L = e.object({
  ruleId: e.coerce.number().pipe(d)
}), R = e.object({
  assetId: e.coerce.number().pipe(i)
}), f = e.object({
  ruleId: e.coerce.number().pipe(I)
}), T = e.object({
  goalId: e.coerce.number().pipe(u)
}), k = e.object({
  rotatorCampaignId: e.coerce.number().pipe(b)
}), x = e.object({
  force: e.coerce.boolean()
});
export {
  v as AdGroupIdParamSchema,
  R as AssetIdParamSchema,
  f as BlacklistAutoRuleIdParamSchema,
  G as CampaignGroupIdParamSchema,
  P as CreativeGroupIdParamSchema,
  j as CreativeIdParamSchema,
  x as ForceActionParamSchema,
  T as GoalIdParamSchema,
  A as LandingGroupIdParamSchema,
  C as LandingIdParamSchema,
  h as MAX_INT4_ID,
  L as PricingRuleIdParamSchema,
  k as RotatorCampaignIdParamSchema,
  l as TargetGroupIdParamSchema,
  g as idListQueryParam
};
//# sourceMappingURL=params.js.map
